var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardMarketplacesellersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "storefront-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 21.7143V11.9643",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3 11.9643V21.7143",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.9283 2.96429H6.07169C5.05029 2.96429 4.12779 3.52679 3.73123 4.39211L1.70154 8.82367C1.0181 10.3148 2.15294 12.0041 3.91357 12.058C3.94482 12.058 3.97607 12.058 4.00732 12.058C5.47919 12.058 6.67216 10.8777 6.67216 9.60976C6.67216 10.8754 7.8656 12.058 9.33748 12.058C10.8094 12.058 12 10.9621 12 9.60976C12 10.8754 13.1929 12.058 14.6648 12.058C16.1367 12.058 17.3301 10.9621 17.3301 9.60976C17.3301 10.9621 18.5231 12.058 19.995 12.058C20.0262 12.058 20.0567 12.058 20.0864 12.058C21.847 12.0032 22.9819 10.3138 22.2984 8.82367L20.2687 4.39211C19.8722 3.52679 18.9497 2.96429 17.9283 2.96429Z",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.5 22.4643H22.5",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.375 14.2143H10.125C10.4234 14.2143 10.7095 14.3328 10.9205 14.5438C11.1315 14.7548 11.25 15.0409 11.25 15.3393V19.4643H5.25V15.3393C5.25 15.0409 5.36853 14.7548 5.5795 14.5438C5.79048 14.3328 6.07663 14.2143 6.375 14.2143Z",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.5 22.4643V15.3393C13.5 15.0409 13.6185 14.7548 13.8295 14.5438C14.0405 14.3328 14.3266 14.2143 14.625 14.2143H17.625C17.9234 14.2143 18.2095 14.3328 18.4205 14.5438C18.6315 14.7548 18.75 15.0409 18.75 15.3393V22.4643",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMarketplacesellersIcon);
export default __webpack_public_path__ + "static/media/dashboard_marketplacesellers_icon.d61e2fb61bc93813b217ead2bed1714c.svg";
export { ForwardRef as ReactComponent };